import { http } from '../lib/http';
import { API_BASE } from '../lib/env';

/**
 * Explicitly ask the server to clear the user's claimed unit.
 * Used before logout flows to guarantee unclaim propagation.
 */
export const requestUnitUnclaim = async (reason = 'manual') => {
  try {
    await http.post('/auth/unclaim-unit', { reason });
  } catch (error) {
    console.warn('[UnitUnclaim] Failed to request unit unclaim:', error);
  }
};

/**
 * Fire-and-forget unit unclaim used during unload events where async work is unreliable.
 * Attempts navigator.sendBeacon first, then falls back to fetch() with keepalive.
 */
export const sendUnitUnclaimBeacon = (reason = 'window-unload') => {
  const endpoint = `${API_BASE}/auth/unclaim-unit`;
  try {
    console.log('[UnitUnclaim] sending keepalive unclaim:', endpoint, reason);
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason }),
      keepalive: true,
      credentials: 'include'
    }).catch(() => {});
  } catch (error) {
    console.warn('[UnitUnclaim] keepalive fetch failed:', error);
  }
};

